<template>
  <v-container fluid class="favourite">
    <v-row class="favourite-content d-none d-md-block">
      <v-col cols="12" class="d-flex justify-space-between">
        <h2 class="py-3">Favourites</h2>
        <!-- <div class="d-flex align-center tools">
          <i class="mdi mdi-share"></i>
          <i class="mdi mdi-heart"></i>
          <i class="mdi mdi-delete"></i>
        </div> -->
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="12">
        <v-text-field
          class="fav-search"
          placeholder="Search"
          solo
          flat
          dense
          small
          hide-details
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="4"
        xl="3"
        class="card-col"
        v-for="product in paginatedProducts"
        :key="product.id"
      >
        <product-card :product="product" />
      </v-col>
    </v-row>
    <v-row v-if="paginatedProducts.length > 0">
      <v-col cols="12" class="pt-0">
        <div class="pagination">
          <div class="pagination-container">
            <v-container class="max-width">
              <v-pagination
                color="#23A0A0"
                v-model="page"
                :circle="circle"
                :disabled="disabled"
                :length="Math.ceil(parseFloat(products.length / totalVisible))"
                :next-icon="nextIcon"
                :prev-icon="prevIcon"
                :page="page"
                :total-visible="totalVisible"
              ></v-pagination>
            </v-container>
          </div>
          <div class="item-per-page mb-5">
            <p>Items Per Page</p>
            <v-text-field
              label="1"
              solo
              flat
              outlined
              dense
              small
              hide-details="auto"
              v-model="totalVisible"
            ></v-text-field>
            <p>
              {{ page }}/{{
                Math.ceil(parseFloat(products.length / totalVisible))
              }}
              Pages
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-else> 
      <v-col cols="12" class="d-flex justify-space-between">
        <p class="py-3">You have not added products to your favourites yet. Once you add favourites, you'll see them here...</p>
       
       
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProductCard from "@/components/Shared/FavouriteProductCard/ProductCard.vue";
import { mapState } from "vuex";

export default {
  name: "FavouriteComponent",
  components: {
    ProductCard
  },
  computed: {
    ...mapState({
      products: state => state.product.favouritesProducts
    }),
    paginatedProducts() {
      let paginatedProducts = [];
      for (
        let i = (this.page - 1) * this.totalVisible;
        i < this.page * this.totalVisible && i < this.products.length;
        i++
      ) {
        paginatedProducts.push(this.products[i]);
      }
      return paginatedProducts;
    }
  },
  mounted() {
    this.$store.dispatch("product/LOAD_FAVOURITES_PRODUCTS", {
      from: 0,
      to: 10
    });
  },
  data: () => ({
    page: 1,
    totalVisible: 10,
    length: 10
  }),
  methods: {
    getNumbers(start, stop) {
      return new Array(stop - start).fill(start).map((n, i) => n + i);
    },
    goToOrder(index) {
      this.$router.push({
        path: "/account/orders/" + index
      });
    }
  }
};
</script>
<style scoped lang="scss" src="./Favourite.scss"></style>
<style lang="scss">
.favourite {
  .v-input {
    .v-label,
    input {
      font-size: 14px;
    }
  }

  .pagination {
    .v-pagination__item {
      color: #aaa;
      outline: none;

      &--active {
        color: #000 !important;
        background-color: transparent !important;
      }
    }

    .v-pagination__navigation i {
      color: #000;
    }

    .v-pagination__navigation,
    .v-pagination__item {
      box-shadow: none;
    }
  }
  .fav-search {
    .v-input__slot {
      background: #f2f2f2 !important;
      border-radius: 5px;
    }
  }
}
</style>
